<script>
import { useVuelidate } from '@vuelidate/core';
import ContactFilter from './ContactFilter.vue';
import DateFilter from './DateFilter.vue';
import LabelFilter from './LabelFilter.vue';
import MemberFilter from './MemberFilter.vue';

import ButtonNext from 'dashboard/components-next/button/Button.vue';

export default {
  components: {
    ContactFilter,
    DateFilter,
    LabelFilter,
    MemberFilter,
    ButtonNext,
  },
  props: {
    board: {
      type: Object,
      default: () => {},
    },
    initialFilters: {
      type: Object,
      default: () => {},
    },
  },
  emits: ['close'],
  setup() {
    return { v$: useVuelidate() };
  },
  data() {
    return {
      filters: {
        members: this.initialFilters.members ?? [],
        contacts: this.initialFilters.contacts ?? [],
        labels: this.initialFilters.labels ?? [],
        dates: this.initialFilters.dates ?? [],
        search: this.initialFilters.search ?? '',
      },
    };
  },
  computed: {
    hasAppliedFilters() {
      return this.$store.getters['wgptBoardListCards/hasFilters'](
        this.board.id
      );
    },
    memberIds() {
      const config = this.board.config ?? {};
      const authorization = config.authorization ?? {};
      const managers = authorization?.managers ?? [];
      const operators = authorization?.operators ?? [];
      const readers = authorization?.readers ?? [];
      return [...managers, ...operators, ...readers];
    },
  },
  watch: {
    filters: {
      handler(filters) {
        this.submitFilters(filters);
      },
      deep: true,
    },
  },
  methods: {
    submitFilters(filters) {
      const boardId = this.board.id;
      const filterOptions = {
        boardId,
        filters,
      };
      this.$store.dispatch('wgptBoardListCards/filter', filterOptions);
    },
    clearFilters() {
      const boardId = this.board.id;
      this.$store.dispatch('wgptBoardListCards/clearFilters', boardId);
      this.$emit('close');
    },
  },
};
</script>

<template>
  <div class="filter-wrapper flex flex-col gap-4">
    <header class="pt-6 ps-6 pe-3 flex justify-between items-center">
      <h3 class="text-base font-medium text-slate-900 dark:text-slate-50">
        {{ $t(`WGPT_BOARDS.FILTER.TITLE`) }}
      </h3>
      <div class="flex gap-2">
        <ButtonNext
          v-if="hasAppliedFilters"
          :label="$t('WGPT_BOARDS.FILTER.BUTTON_TXT.CLEAR_FILTER')"
          size="sm"
          color="ruby"
          variant="faded"
          @click="clearFilters"
        />
        <ButtonNext
          icon="i-lucide-x"
          size="sm"
          color="slate"
          variant="ghost"
          @click="$emit('close')"
        />
      </div>
    </header>

    <div
      class="flex-1 overflow-auto px-6 pb-8 flex flex-col items-stretch gap-4"
    >
      <ContactFilter v-model="filters.contacts" />

      <MemberFilter v-model="filters.members" :member-ids="memberIds" />

      <DateFilter v-model="filters.dates" />

      <LabelFilter v-model="filters.labels" />
    </div>
  </div>
</template>

<style lang="scss" scoped>
.filter-wrapper {
  @apply w-96;
  max-height: min(590px, 75vh);
}
</style>
